import internalStateService from "../app/InternalStateService";

function registerReducers(reducersSubset, state, action) {
    for (let ActionType in reducersSubset) {
        if (reducersSubset.hasOwnProperty(ActionType)) {
            if (action.type === ActionType) {
                return reducersSubset[ActionType](state, action);
            }
        }
    }

    return state;
}

export function global(state, action) {
    const ReducersMap = internalStateService.getReducers();
    let GlobalReducers = ReducersMap.global;

    return registerReducers(GlobalReducers, state, action);
}

export function config(state, action) {
    const ReducersMap = internalStateService.getReducers();
    let ConfigReducers = ReducersMap.config;

    return registerReducers(ConfigReducers, state, action);
}

export function data(state, action) {
    const ReducersMap = internalStateService.getReducers();
    let DataReducers = ReducersMap.data;

    return registerReducers(DataReducers, state, action);
}

export function routes(state, action) {
    const ReducersMap = internalStateService.getReducers();
    let RoutesReducers = ReducersMap.routes;

    return registerReducers(RoutesReducers, state, action);
}

export function dashboards(state, action) {
    const ReducersMap = internalStateService.getReducers();
    let DashboardReducers = ReducersMap.dashboards;

    return registerReducers(DashboardReducers, state, action);
}

export function login(state, action) {
    const ReducersMap = internalStateService.getReducers();
    let LoginReducers = ReducersMap.login;

    return registerReducers(LoginReducers, state, action);
}

export function uiState(state, action) {
    const ReducersMap = internalStateService.getReducers();
    let uiStateReducers = ReducersMap.uiState;

    return registerReducers(uiStateReducers, state, action);
}

export function windowSize(state, action) {
    const ReducersMap = internalStateService.getReducers();
    let windowSizeReducers = ReducersMap.windowSize;

    return registerReducers(windowSizeReducers, state, action);
}

export function messages(state, action) {
    const ReducersMap = internalStateService.getReducers();
    let messagesReducers = ReducersMap.messages;

    return registerReducers(messagesReducers, state, action);
}

export function notifications(state, action) {
    const ReducersMap = internalStateService.getReducers();
    let notificationsReducers = ReducersMap.notifications;

    return registerReducers(notificationsReducers, state, action);
}

export function actions(state, action) {
    const ReducersMap = internalStateService.getReducers();
    let actionsReducers = ReducersMap.actions;

    return registerReducers(actionsReducers, state, action);
}
